import React, { PureComponent } from 'react'
import { connect } from 'react-redux'
import ContainerWithTitle from '../../HOC/ContainerWithTitle'
import { SearchBarConnect } from '../../../components/MasterCatalog/SearchBar'
import { openErrorMessage } from '../../../actions/message'
import { MenuItem, Grid, Menu } from '@material-ui/core'
import { createFakeServer } from './MasterCategoryGrouping'
import {
  getListCategories,
  setListCategories,
  getCombinedCategoryList,
  getComplianceCategoryList,
  setAdoptionModeMasterProducts,
  unlinkCategoriesFromParent,
  getMasterCategory,
  updateSingleMasterCategories,
} from '../../../actions/masterCatalog'
import FormMasterCategory from '../../../components/MasterCatalog/FormMasterCategory'
import { getShopList } from '../../../actions/shop'
import ModalUpdateMasterCategory from '../../../components/MasterCatalog/ModalUpdateMasterCategory'
import {
  updateArchiveMasterCategory,
  bulkUpdateChildCategories,
} from '../../../actions/masterCatalog'
import { getAgGridViewsAPI } from '../../../api/ag-grid-views'
import {
  hasKeys,
  categoryTypes,
  topLevelCategories,
  unitTypes,
  CHILD_SOURCE,
  PARENT_SOURCE,
  ORPHAN_SOURCE,
} from '../../../utils/common'
import { catalogTestingViews } from '../../../utils/constants'
import ConfirmationModal from '../../../components/MasterCatalog/ConfirmationModal'
import { EditableSelect, EditableTextField } from '../../../components/common/EditableComponents'
import AgGrid from '../../../components/ag_grid/AgGrid'
import { hideZendesk, showZendesk } from '../../../utils/crm'

import { LinkValue, SameValue } from '../../../assets'

import {
  AmountComponent,
  StatusComponent,
  ActiveInactiveComponent,
  MCStatusComponent,
  MCCategoryNameComponent,
  MCDataDropdownComponent,
  MCCategoryImageComponent,
  MCComplianceCatDropdownComponent,
} from '../../../components/MasterCatalog/Components'
import {
  AmountEditor,
  StatusEditor,
  MCStatusEditor,
  MCTextEditor,
  MCDataDropdownEditor,
  MCComplianceCatDropdownEditor,
} from '../../../components/MasterCatalog/Components'

import { cannabisTypeOptionsList } from '../../../utils/common'
import { getSession } from '../../../utils/api'
import { getStateCannabisDefinitionActions } from '../../../actions/compliance'
import { isFeatureFlagEnable } from '../../../api/unleash'
import { UnleashToggles } from '../../../types/unleashToggles'
import { updateProperties } from '../../../utils/catalog/masterCategory'

const ITEM_HEIGHT = 48

const cellStyle = {
  borderLeft: '1px solid #EEEEEE !important',
  borderRight: '1px solid #EEEEEE !important',
}

let timeout

class MasterCatalog extends PureComponent {
  constructor(props) {
    super(props)

    this.state = {
      columnDefs: [
        {
          field: 'photo',
          headerName: 'Image',
          minWidth: 125,
          filter: false,
          sortable: false,
          dataFieldName: 'image',
          cellRenderer: 'MCCategoryImageComponent',
          cellRendererParams: {
            onSyncChildEvent: this.onSyncChildEvent,
          },
        },
        {
          field: 'cannabis',
          headerName: 'Category Type',
          minWidth: 200,
          cellRenderer: 'MCDataDropdownComponent',
          editable: true,
          cellRendererParams: {
            dropDownDataType: 'LabelValue',
            onSyncChildEvent: this.onSyncChildEvent,
            getDataOptions: this.getCategoryTypesMap,
          },
          cellEditor: 'MCDataDropdownEditor',
          cellEditorParams: {
            dropDownDataType: 'LabelValue',
            getDataOptionsList: this.getCategoryTypes,
          },
        },
        {
          field: 'topLevelCategoryName',
          headerName: 'Top Level',
          minWidth: 200,
          cellRenderer: 'MCDataDropdownComponent',
          editable: true,
          cellRendererParams: {
            dropDownDataType: 'LabelValue',
            onSyncChildEvent: this.onSyncChildEvent,
            getDataOptions: this.getTopLevelCategoriesMap,
          },
          dataFieldName: 'topLevelCategory',
          cellEditor: 'MCDataDropdownEditor',
          cellEditorParams: {
            dropDownDataType: 'LabelValue',
            getDataOptionsList: this.getTopLevelCategories,
          },
        },
        {
          field: 'cannabisType',
          headerName: 'Cannabis Type',
          minWidth: 200,
          cellRenderer: 'MCDataDropdownComponent',
          editable: true,
          cellRendererParams: {
            dropDownDataType: 'LabelValue',
            onSyncChildEvent: this.onSyncChildEvent,
            getDataOptions: this.getCannabisTypesMap,
          },
          dataFieldName: 'cannabisType',
          cellEditor: 'MCDataDropdownEditor',
          cellEditorParams: {
            dropDownDataType: 'LabelValue',
            getDataOptionsList: this.getCannabisTypes,
          },
        },
        {
          field: 'complianceId',
          headerName: 'Compliance Category',
          minWidth: 200,
          cellRenderer: 'MCComplianceCatDropdownComponent',
          editable: true,
          dataFieldName: 'complianceCategoryId',
          cellRendererParams: {
            getDataOptions: this.getComplianceCategoriesMap,
          },
          cellEditor: 'MCComplianceCatDropdownEditor',
          cellEditorParams: {
            getDataOptionsList: this.getComplianceCategories,
          },
        },
        {
          field: 'unitType',
          headerName: 'Measurement',
          minWidth: 200,
          cellRenderer: 'MCDataDropdownComponent',
          editable: true,
          cellRendererParams: {
            dropDownDataType: 'LabelValue',
            onSyncChildEvent: this.onSyncChildEvent,
            getDataOptions: this.getUnitTypesMap,
          },
          cellEditor: 'MCDataDropdownEditor',
          cellEditorParams: {
            dropDownDataType: 'LabelValue',
            getDataOptionsList: this.getUnitTypes,
          },
        },
        {
          field: 'lowThreshold',
          headerName: 'LIT Threshold',
          minWidth: 150,
          editable: true,
          cellEditor: 'AmountEditor',
          cellRenderer: 'AmountComponent',
          cellRendererParams: {
            hideCurrency: true,
            onSyncChildEvent: this.onSyncChildEvent,
          },
        },
        {
          field: 'archived',
          headerName: 'Archived',
          minWidth: 150,
          editable: true,
          cellRenderer: 'MCStatusComponent',
          cellEditor: 'MCStatusEditor',
          cellRendererParams: {
            options: ['No', 'Yes'],
            onSyncChildEvent: this.onSyncChildEvent,
          },
          cellEditorParams: {
            options: ['No', 'Yes'],
          },
        },
      ],
      complianceCategories: [],
      autoGroupColumnDef: {
        field: 'name',
        headerName: 'Category Name',
        minWidth: 250,
        pinned: true,
        cellRendererParams: {
          innerRenderer: 'MCCategoryNameComponent',
          checkEvent: this.handleCheck,
          menuEvent: this.handleMenu,
          adoptionMode: false,
          selectedRows: [],
          property: '',
          suppressCount: true,
          selectedProducts: [],
          refreshStrategy: 'rows',
          checkbox: true,
        },
      },
      defaultColDef: {
        flex: 1,
        filter: true,
        sortable: true,
        resizable: true,
        headerClass: 'catalog-aggrid-header',
        cellClass: 'catalog-aggrid-cell',
        cellStyle: cellStyle,
      },
      paginationPageSize: 20,
      pageNumber: 1,
      checkActive: false,
      checkInactive: false,
      checkArchived: false,
      childCategories: [],
      anchorEl: null,
      selectedRows: [],
      showModalConfirmation: false,
      modalCategoryMaster: false,
      optionToBulkUpdate: null,
      selectedMasterCategory: null,
      selectedView: {},
      views: [],
      viewType: catalogTestingViews.MASTER_CATEGORIES.value,
      updateOption: true,
      typeCategory: 'master',
      term: '',
      filter: ['ACTIVE', 'INACTIVE'],
      rowModelType: 'serverSide',
      serverSideStoreType: 'partial',
      isServerSideGroupOpenByDefault: function () {
        return false
      },
      isServerSideGroup: function (dataItem) {
        return dataItem.group
      },
      getServerSideGroupKey: function (dataItem) {
        return dataItem.id
      },
      groupDefaultExpanded: 0,
      getRowNodeId: function (data) {
        return data.id
      },
      categoryActions: [],
      openMasterCategorySideBar: false,
      selectedCategoryType: '',
      adoptionMode: false,
      numEnterKeyPage: 0,
      cannabisTypeForState: false,
      cannabisTypeList: {},
    }

    this.onGridReady = this.onGridReady.bind(this)
    this.handleChange = this.handleChange.bind(this)
    this.updateMasterCategory = this.updateMasterCategory.bind(this)
    this.updateListCategory = this.updateListCategory.bind(this)
    this.onPaginationChanged = this.onPaginationChanged.bind(this)
  }

  componentDidMount() {
    const user = getSession()
    const { company = {} } = user || {}
    let request = []
    request.push(this.getViews())
    this.props.dispatch(getShopList())
    this.props.dispatch(getComplianceCategoryList()).then((res) => {
      this.setState({
        complianceCategories: res.values,
      })
    })

    isFeatureFlagEnable(UnleashToggles.CANNABIS_TYPE_FOR_STATE).then((res) => {
      if (res) {
        this.props.dispatch(getStateCannabisDefinitionActions(company)).then((cannabisTypeList) => {
          this.setState({
            cannabisTypeList,
            cannabisTypeForState: res,
          })
        })
      }
    })

    this.props.dispatch(setAdoptionModeMasterProducts(false))
    localStorage.removeItem('ADOPTION_MODE')
    localStorage.removeItem('ADOPTION_MODE_VERIFY')
  }

  componentWillReceiveProps(nextProps) {
    const { companyFeatures = {} } = this.props.companyReducer || {}
    if (companyFeatures.enableMasterCatalog != null && !companyFeatures.enableMasterCatalog) {
      return this.props.history.push('/')
    }

    if (nextProps.selectedView !== this.props.selectedView) {
      this.gridApi.gridCore.sideBarComp.toolPanelWrappers[2].toolPanelCompInstance.componentInstance.setSelectedView(
        nextProps.selectedView && nextProps.selectedView.data,
      )
    }
    if (hasKeys(this.props.data) && hasKeys(nextProps.data) && this.props.data !== nextProps.data) {
      this.props.dispatch(setListCategories(nextProps.data))
      this.setState({
        dataFiltered: false,
      })
    }
  }

  onGridReady = (params) => {
    this.gridApi = params.api
    this.processOnGrid()
  }

  processOnGrid = () => {
    const { typeCategory, term, filter } = this.state
    this.gridApi.deselectAll()
    this.gridApi.setServerSideDatasource(
      this.serverSideDatasource(typeCategory, { term: term || '' }, { filter: filter || [] }),
    )
  }

  serverSideDatasource = (typeCategory, { term = '' }, { filter = [] }) => {
    const $this = this
    return {
      getRows: function (params) {
        if (params.parentNode.data) {
          let server = createFakeServer([params.parentNode.data])
          let response = server.getData(params.request)
          setTimeout(function () {
            params.successCallback(response, response.length)
          }, 200)
        } else {
          let page = params.request.endRow / 20
          $this.props
            .dispatch(getCombinedCategoryList((page - 1) * 20, 20, term, filter, typeCategory))
            .then((res) => {
              if (res.total > 0) {
                let lastRow = () => {
                  return res.total || -1
                }
                const processData = $this.dataFormatter(res && res.values)
                let server = createFakeServer(processData)
                let response = server.getData(params.request)
                setTimeout(function () {
                  params.successCallback(response, lastRow())
                }, 200)
                $this.setState({
                  fullData: processData,
                })
              } else {
                params.successCallback([], 0)
              }
            })
        }
      },
    }
  }

  dataFormatter = (data = []) => {
    let result = []
    if (data)
      data.forEach((product) => {
        let newProduct = product.orphan ? product.orphan : product.master
        result.push(newProduct)
      })
    return result
  }

  updateData = (data) => {
    this.setState({ fullData: data })
    this.props.dispatch(setListCategories(data))
  }

  onRowSelected = (event) => {
    const rows = event.api.getSelectedNodes().map((row) => {
      return row.data
    })
    this.setState({ selectedRows: rows })
  }

  updateListCategory = () => {
    this.processOnGrid()
    this.handleClose()
  }

  handleChange = (check, event) => {
    this.setState(
      {
        [check]: event.target.checked,
      },
      () => {
        this.manageFilterSearchBar()
      },
    )
  }

  manageFilterSearchBar = () => {
    const { fullData, checkActive, checkInactive, checkArchived } = this.state

    let dataActive = []
    let dataInactive = []
    let dataArchived = []

    if (checkActive) {
      dataActive = fullData.filter((c) => c.active === checkActive)
    } else if (checkInactive) {
      dataInactive = fullData.filter((c) => !c.active === checkInactive)
    } else if (checkArchived) {
      dataArchived = fullData.filter((c) => c.archived === checkArchived)
    }

    const newRowData = checkActive
      ? dataActive
      : checkInactive
      ? dataInactive
      : checkArchived
      ? dataArchived
      : fullData
    this.props.dispatch(setListCategories(newRowData))
  }

  bulkUpdate = (option) => {
    this.setState({
      modalCategoryMaster: true,
      optionToBulkUpdate: option,
    })
  }

  updateArchiveMasterCategory = () => {
    const { selectedMasterCategory } = this.state
    const data = {
      masterCategoryId: selectedMasterCategory.id,
      isArchived: !selectedMasterCategory.archived,
    }
    this.props.dispatch(updateArchiveMasterCategory(data)).then((response) => {
      this.props.dispatch(getListCategories())
    })
  }

  handleClickOpen = (create = true) => {
    hideZendesk()
    if (create) {
      this.setState({
        selectedMasterCategory: null,
      })
    }
    this.setState({ openMasterCategorySideBar: true, updateOption: !create })
  }

  handleClose = () => {
    showZendesk()
    this.setState({
      openMasterCategorySideBar: false,
      selectedMasterCategory: null,
    })
  }

  onFilterTextBoxChanged = (e) => {
    const term = e.target.value
    const { typeCategory = 'master' } = this.state
    const { filter = [] } = this.props.filter || {}

    this.setState({ term: term })
    clearTimeout(timeout)
    timeout = setTimeout(() => {
      if (!term) {
        this.gridApi.setServerSideDatasource(
          this.serverSideDatasource(typeCategory, { term: '' }, { filter: filter.join() }),
        )
      }

      if (term) {
        this.setState({
          timeout: setTimeout(() => {
            if (term) {
              this.gridApi.setServerSideDatasource(
                this.serverSideDatasource(typeCategory, { term: term }, { filter: filter.join() }),
              )
            }
          }, 500),
        })
      }
    }, 1500)
  }

  onFilterSwitchChanged = (state) => {
    const { typeCategory = 'master', term } = this.state
    let filterResult = state.map((filter) => filter.value) || []
    this.setState({
      filter: filterResult,
    })
    this.gridApi.setServerSideDatasource(
      this.serverSideDatasource(typeCategory, { term: term }, { filter: filterResult.join() }),
    )
  }

  handleCloseModalCategoryMaster = (update) => {
    this.setState({
      modalCategoryMaster: false,
    })
    if (update === true) {
      this.setState(
        {
          selectedRows: [],
          optionToBulkUpdate: null,
        },
        () => {
          this.handleDeactivateAdoptionMode()
        },
      )
      this.props.dispatch(getListCategories())
    }
  }

  getViews = () => {
    getAgGridViewsAPI(catalogTestingViews.MASTER_CATEGORIES.value).then((res) => {
      this.setState({
        views: res.values,
      })
    })
  }

  handleCategoryFilterChange = (value) => {
    this.setState(
      {
        typeCategory: value,
        selectedRows: [],
        selectedCategoryType: '',
      },
      () => {
        this.processOnGrid()
      },
    )
  }

  handleMenu = (image, data) => {
    let actions = [{ key: 'edit', value: 'Edit' }]
    if (data.parentCategoryId) {
      actions.push({ key: 'makeOrphan', value: 'Make Orphan' })
    }

    this.setState({
      anchorEl: image.currentTarget,
      categoryActions: actions,
      auxSelectedMasterCat: data,
    })
  }

  handleCloseMenu = () => {
    this.setState({ anchorEl: null })
    this.closeConfirmationModal()
  }

  updateMasterCategory = (key) => {
    switch (key) {
      case 'archive':
        this.updateArchiveMasterCategory()
        break
      case 'edit':
        this.handleClickOpen(false)
        break
      case 'makeOrphan':
        this.makeOrphan()
        break
      default:
        break
    }
    this.handleCloseMenu()
  }

  handleActionEvent = (key) => {
    let data = null
    switch (key) {
      case 'edit':
        this.setState({
          selectedMasterCategory: this.state.auxSelectedMasterCat,
        })
        this.updateMasterCategory(key)
        break
      case 'makeOrphan':
        this.setState({
          selectedMasterCategory: this.state.auxSelectedMasterCat,
        })
        data = {
          title: 'Unlink from Parent',
          description:
            'Making it an Orphan keeps the Parent values. Updating will make it an Orphan, while not updating will keep as a Child.',
        }
        break
      default:
        break
    }
    if (data) {
      this.setState({
        key,
        modalDetail: data,
        showModalConfirmation: true,
      })
    }
  }

  closeConfirmationModal = () => {
    this.setState({
      key: '',
      modalDetail: {},
      showModalConfirmation: false,
    })
  }

  makeOrphan = () => {
    const { selectedMasterCategory } = this.state
    this.props.dispatch(unlinkCategoriesFromParent(selectedMasterCategory.id)).then(() => {
      this.props.dispatch(getMasterCategory(selectedMasterCategory.parentCategoryId)).then((mp) => {
        const resShopIds = mp.childCategories.map((category) => category.shopId)
        const shopsSelected =
          resShopIds.filter((shopId) => shopId !== selectedMasterCategory.shopId) || []

        if (mp.childCategories && mp.childCategories.length == 0) {
          const data = {
            masterCategoryId: selectedMasterCategory.parentCategoryId,
            isArchived: true,
          }
          this.props.dispatch(updateArchiveMasterCategory(data)).then(() => {
            const newData = { ...mp, shopIds: shopsSelected }
            this.props.dispatch(updateSingleMasterCategories(newData)).then(() => {
              this.getAllMasterCategories()
            })
          })
        } else {
          const newData = { ...mp, shopIds: shopsSelected }
          this.props.dispatch(updateSingleMasterCategories(newData)).then(() => {
            this.getAllMasterCategories()
          })
        }
        this.setState({ selectedMasterCategory: null })
      })
    })
  }

  getAllMasterCategories = () => {
    this.processOnGrid()
  }

  handleCheck = (check, data) => {
    let result = [...this.state.selectedRows] || []
    const { adoptionMode } = this.state
    let property = ''
    if (data.childCategories) {
      property = 'parent'
    } else if (!data.parentCategoryId) {
      property = 'orphan'
    } else {
      property = 'child'
    }

    if (check.target.checked) {
      if (adoptionMode && property === 'parent') {
        if (result.length > 0) {
          this.setState({}, () => {
            this.props.dispatch(
              openErrorMessage('Only one master category can be selected at a time.'),
            )
          })
          return
        }
      }
      result.push(data)
    } else {
      result = result.filter((c) => c.id !== data.id)
    }
    this.setState(
      {
        selectedRows: result,
        selectedCategoryType: property,
      },
      () => {
        //TODO:
      },
    )
  }

  //Reset column group
  handleAdoptionMode = () => {
    const { selectedRows, selectedCategoryType, adoptionMode } = this.state

    this.setState({
      adoptionMode: adoptionMode,
    })
  }

  handleDeactivateAdoptionMode = () => {
    this.setState({
      selectedMasterCategory: null,
      typeCategory: 'master',
      adoptionMode: false,
      selectedRows: [],
      selectedCategoryType: '',
    })
    localStorage.removeItem('ADOPTION_MODE')
    localStorage.removeItem('ADOPTION_MODE_VERIFY')
  }

  handleCloseEverything = (update) => {
    this.handleDeactivateAdoptionMode()

    if (this.state.typeCategory == 'master') {
      this.handleChangeTypeProduct('master')
    } else {
      this.handleChangeTypeProduct('orphan')
    }

    if (update) {
      this.processOnGrid()
    }
    this.setState({
      selectedMasterCategory: null,
    })
  }

  handleChangeTypeProduct = (value) => {
    this.uncheckAllCheckboxes()

    this.setState(
      {
        typeCategory: value,
        selectedRows: [],
        selectedCategoryType: '',
      },
      () => {
        this.processOnGrid()
      },
    )
  }

  uncheckAllCheckboxes() {
    var checkboxes = document.querySelectorAll('.check-name')
    for (var checkbox of checkboxes) {
      checkbox.checked = false
    }
  }

  onPaginationChanged() {
    if (this.gridApi) {
      let totalPages = this.gridApi.paginationGetTotalPages()
      let currentPage = this.gridApi.paginationGetCurrentPage() + 1
      let totalRows = this.gridApi.paginationGetRowCount()
      let pageSize = this.gridApi.paginationGetPageSize()
      let fromRow = this.gridApi.paginationGetCurrentPage() * pageSize + 1
      let toRow = (this.gridApi.paginationGetCurrentPage() + 1) * pageSize
      toRow = toRow > totalRows ? totalRows : toRow

      this.setText('#ag-445-of-page-number', totalPages)
      this.setText('#ag-445-start-page-number', currentPage)
      this.setText('#ag-445-first-row', fromRow)
      this.setText('#ag-445-last-row', toRow)
      this.setText('#ag-445-row-count', totalRows)

      this.setButtonDisabled('#btFirst', currentPage <= 1)
      this.setButtonDisabled('#btPrevious', currentPage <= 1)
      this.setButtonDisabled('#btNext', totalPages == currentPage)
      this.setButtonDisabled('#btLast', totalPages == currentPage)
    }
  }

  getLabelValueMap = (listItems) => {
    const itemsMap = {}
    listItems.forEach((t) => {
      itemsMap[t.value] = t
    })
    return itemsMap
  }

  getCategoryTypes = () => {
    return categoryTypes
  }

  getCategoryTypesMap = () => {
    return this.getLabelValueMap(categoryTypes)
  }

  getTopLevelCategories = () => {
    return topLevelCategories
  }

  getTopLevelCategoriesMap = () => {
    return this.getLabelValueMap(topLevelCategories)
  }

  getUnitTypes = () => {
    return unitTypes
  }

  getCannabisTypes = () => {
    return cannabisTypeOptionsList
  }

  getCannabisTypesMap = () => {
    return this.getLabelValueMap(cannabisTypeOptionsList)
  }

  getUnitTypesMap = () => {
    return this.getLabelValueMap(unitTypes)
  }

  getComplianceCategories = (shopId) => {
    const compliancesForShop =
      this.props.masterCatalogReducer.complianceCategories.filter(
        (comp) => comp.shopId == shopId,
      ) || []
    return compliancesForShop
  }

  getComplianceCategoriesMap = () => {
    const itemsMap = {}
    const listItems = this.props.masterCatalogReducer.complianceCategories || []
    listItems.forEach((t) => {
      itemsMap[t.id] = t
    })
    return itemsMap
  }

  onSyncChildEvent = (params, state) => {
    const { icon } = state
    const { data, colDef } = params

    if (icon === LinkValue || icon === SameValue) return
    if (!data.parentCategoryId || !params.node.parent) return

    const parent = params.node.parent
    const newValue = parent.data[colDef.field]
    const newSourceMap = {
      ...data.sourceMap,
      [colDef.field]: PARENT_SOURCE,
    }

    this.updateChildrenCategories(
      [data.id],
      newSourceMap,
      newValue,
      colDef.dataFieldName || colDef.field,
    )
      .then((res) => {
        const newData = {
          ...data,
          [colDef.field]: newValue,
          sourceMap: newSourceMap,
        }
        params.node.setData(newData)
        this.updateParentData(newData, params.node.parent)
      })
      .catch((err) => {
        console.log({ err })
        params.node.setData({ ...params.data, [colDef.field]: params.oldValue })
      })
  }

  updateRowData = (params) => {
    const { data, colDef } = params
    const { field } = colDef
    const isParent = !!data.children
    const isChild = !!data.parentCategoryId

    const newValue = params.newValue
    if (isParent) {
      let newData = {
        ...data,
        [field]: newValue,
      }
      const parentNode = this.gridApi.getRowNode(params.node.id)
      this.props
        .dispatch(updateSingleMasterCategories(newData))
        .then((res) => {
          if (data.children) {
            for (const [cIndex, childData] of data.children.entries()) {
              if (childData) {
                const sourceDef =
                  (childData.sourceMap && childData.sourceMap[field]) || CHILD_SOURCE
                if (sourceDef === PARENT_SOURCE) {
                  this.updateChildrenCategories(
                    [childData.id],
                    childData.sourceMap,
                    newValue,
                    colDef.dataFieldName || colDef.field,
                  )
                    .then((res) => {
                      const childRow = params.api.getRowNode(`${parentNode.key}-${cIndex}`)
                      if (childRow) {
                        childData[field] = newValue
                        childRow.setData(childData)
                      }
                    })
                    .catch((err) => {
                      console.log({ err })
                    })
                }
              }
            }
          }
          if (field === 'archived') this.processOnGrid()
        })
        .catch((err) => {
          console.log({ err })
          params.node.setData({ ...params.data, [field]: params.oldValue })
        })
    } else {
      const parent = params.node.parent
      let newSourceMap = null

      if (isChild && parent && parent.data) {
        newSourceMap = {
          ...data.sourceMap,
          [colDef.field]: data[field] === parent.data[field] ? PARENT_SOURCE : CHILD_SOURCE,
        }
      }

      this.updateChildrenCategories(
        [data.id],
        newSourceMap,
        newValue,
        colDef.dataFieldName || colDef.field,
      )
        .then((res) => {
          const newData = {
            ...data,
            [colDef.field]: newValue,
            sourceMap: newSourceMap,
          }
          params.node.setData(newData)
          if (isChild) {
            this.updateParentData(newData, params.node.parent)
          }
        })
        .catch((err) => {
          console.log({ err })
          params.node.setData({ ...params.data, [field]: params.oldValue })
        })
    }
  }

  updateParentData = (updChild, masterRow) => {
    if (!masterRow) return

    const parentData = masterRow.data
    parentData.children = parentData.children.map((child) => {
      return child.id === updChild.id ? updChild : child
    })
    masterRow.setData(parentData)
  }

  updateChildrenCategories = (categoryIds, newSourceMap, newValue, field) => {
    return new Promise((resolve, reject) => {
      const option = updateProperties.find((prop) => prop.field === field)
      if (!option) {
        return this.props.dispatch(openErrorMessage('Option not found for update'))
      }

      if (field === 'cannabis') field = 'isCannabis'

      const requestData = {
        childCategoriesIds: categoryIds,
        sourceMap: newSourceMap,
        bulkType: option.bulkType,
        [field]: newValue,
      }

      this.props
        .dispatch(bulkUpdateChildCategories(requestData))
        .then((res) => {
          resolve(res)
        })
        .catch((err) => {
          reject(err)
        })
    })
  }

  setText(selector, text) {
    document.querySelector(selector).innerHTML = text
  }

  setButtonDisabled(selector, disabled) {
    let classDisable = 'ag-disabled'

    if (disabled) {
      document.querySelector(selector).classList.add(classDisable)
    } else {
      document.querySelector(selector).classList.remove(classDisable)
    }
  }

  saveParentCategory = (category) => {
    this.setState({
      selectedMasterCategory: category,
    })
  }

  onBtFirst() {
    this.gridApi.paginationGoToFirstPage()
  }

  onBtLast() {
    this.gridApi.paginationGoToLastPage()
  }

  onBtNext() {
    this.gridApi.paginationGoToNextPage()
  }

  onBtPrevious() {
    this.gridApi.paginationGoToPreviousPage()
  }

  onBtNumberPage(page) {
    let numPage = parseInt(page) - 1
    this.gridApi.paginationGoToPage(numPage)
  }

  onBtNumberPageChange(event) {
    this.setState({
      numEnterKeyPage: event.target.value,
    })
  }

  onBtNumberPageKeyDown(event) {
    const { numEnterKeyPage } = this.state

    if (event.key === 'Enter') {
      this.onBtNumberPage(numEnterKeyPage)
    }
  }

  render() {
    const {
      checkActive,
      checkInactive,
      checkArchived,
      openMasterCategorySideBar,
      anchorEl,
      modalCategoryMaster,
      selectedCategoryType,
      selectedRows,
      optionToBulkUpdate,
      selectedView = {},
      views = [],
      updateOption,
      typeCategory,
      groupDefaultExpanded,
      serverSideStoreType,
      selectedMasterCategory,
      categoryActions,
      adoptionMode,
      filter,
      term,
      showModalConfirmation,
      key,
      modalDetail,
      cannabisTypeList,
      cannabisTypeForState,
    } = this.state

    const { shopsList = {} } = this.props.shopReducer
    const open = Boolean(anchorEl)

    return (
      <React.Fragment>
        <Grid container>
          <Grid item xs={12}>
            <SearchBarConnect
              checkActive={checkActive}
              checkInactive={checkInactive}
              checkArchived={checkArchived}
              handleChange={this.handleChange}
              handleFilterChange={this.onFilterSwitchChanged}
              buttonText={'New Category'}
              openModal={this.handleClickOpen}
              handleTermChange={this.onFilterTextBoxChanged}
              filter={filter}
              bulkUpdate={this.bulkUpdate}
              selectedCategories={selectedRows}
              processOnGrid={this.processOnGrid}
              term={term}
              hidden={true}
              updateData={this.updateData}
              typeCategory={typeCategory}
              handleAdoptionMode={this.handleAdoptionMode}
              deactivateAdoptionMode={this.handleDeactivateAdoptionMode}
              closeEverything={this.handleCloseEverything}
              handleCategoryFilterChange={this.handleCategoryFilterChange}
              saveParentCategory={this.saveParentCategory}
              selectedParentCategory={this.state.selectedMasterCategory}
              selectedCategoryType={selectedCategoryType}
            />
          </Grid>
          <Grid item xs={12} container>
            <Grid className="labelField" item xs={6} sm={6} md={6} lg={2}>
              <p>
                {(selectedRows && selectedRows.length) || 0} {selectedCategoryType} categories
                selected
              </p>
            </Grid>
            {!adoptionMode && (
              <Grid className="editField" item xs={4} sm={4} md={2}>
                <EditableSelect
                  style={{ width: '20%' }}
                  name="type"
                  value={typeCategory}
                  valueToRender={typeCategory}
                  onChange={(event) => this.handleCategoryFilterChange(event.target.value)}
                  material={false}
                  editMode={true}
                >
                  <MenuItem value="master">Master Categories</MenuItem>
                  <MenuItem value="orphan">Orphan Categories</MenuItem>
                </EditableSelect>
              </Grid>
            )}
          </Grid>
          <Grid item xs={12} container>
            <Grid item xs={12}>
              <div
                className="ag-theme-alpine container-aggrid"
                style={{ height: '70vh', marginBottom: '30px' }}
              >
                <AgGrid
                  columnDefs={this.state.columnDefs.map((col) => ({ ...col, obj: 'CATEGORY' }))}
                  defaultColDef={this.state.defaultColDef}
                  rowHeight={40}
                  autoGroupColumnDef={this.state.autoGroupColumnDef}
                  enableGroupEdit={true}
                  rowSelection={'multiple'}
                  frameworkComponents={{
                    AmountComponent,
                    StatusComponent,
                    ActiveInactiveComponent,
                    MCStatusComponent,
                    MCCategoryNameComponent,
                    MCDataDropdownComponent,
                    MCCategoryImageComponent,
                    MCComplianceCatDropdownComponent,
                    MCStatusEditor,
                    StatusEditor,
                    AmountEditor,
                    MCTextEditor,
                    MCDataDropdownEditor,
                    MCComplianceCatDropdownEditor,
                  }}
                  animateRows={true}
                  selectedView={selectedView}
                  views={views}
                  onGridReady={this.onGridReady}
                  gridApi={this.gridApi}
                  updateListCategory={this.updateListCategory}
                  suppressRowClickSelection={true}
                  pagination={true}
                  paginationPageSize={this.state.paginationPageSize}
                  groupDefaultExpanded={groupDefaultExpanded}
                  treeData={true}
                  rowModelType={this.state.rowModelType}
                  cacheBlockSize={20}
                  maxBlocksInCache={20}
                  serverSideStoreType={serverSideStoreType}
                  isServerSideGroupOpenByDefault={this.state.isServerSideGroupOpenByDefault}
                  isServerSideGroup={this.state.isServerSideGroup}
                  getServerSideGroupKey={this.state.getServerSideGroupKey}
                  onCellValueChanged={this.updateRowData}
                  onRowSelected={this.onRowSelected}
                  sideBar={{
                    toolPanels: [
                      {
                        id: 'columns',
                        labelDefault: 'Columns',
                        labelKey: 'columns',
                        iconKey: 'columns',
                        toolPanel: 'agColumnsToolPanel',
                        toolPanelParams: {
                          suppressRowGroups: true,
                          suppressValues: true,
                          suppressPivots: true,
                          suppressPivotMode: true,
                        },
                      },
                    ],
                  }}
                  onPaginationChanged={this.onPaginationChanged}
                  suppressPaginationPanel={true}
                />
                <div
                  class="ag-paging-panel ag-unselectable pagination-position"
                  id="ag-445"
                  aria-live="polite"
                  aria-describedby="ag-445-start-page ag-445-start-page-number ag-445-of-page ag-445-of-page-number ag-445-first-row ag-445-to ag-445-last-row ag-445-of ag-445-row-count"
                >
                  <span class="ag-paging-row-summary-panel" aria-hidden="true">
                    <span
                      id="ag-445-first-row"
                      ref="lbFirstRowOnPage"
                      class="ag-paging-row-summary-panel-number"
                    >
                      0
                    </span>
                    <span id="ag-445-to"> to </span>
                    <span
                      id="ag-445-last-row"
                      ref="lbLastRowOnPage"
                      class="ag-paging-row-summary-panel-number"
                    >
                      0
                    </span>
                    <span id="ag-445-of"> of </span>
                    <span
                      id="ag-445-row-count"
                      ref="lbRecordCount"
                      class="ag-paging-row-summary-panel-number"
                    >
                      0
                    </span>
                  </span>
                  <EditableTextField
                    placeholder={'Page'}
                    editMode={true}
                    material={false}
                    style={{ maxWidth: '5em', margin: 'unset' }}
                    onChange={(e) => this.onBtNumberPageChange(e)}
                    onKeyDown={(e) => this.onBtNumberPageKeyDown(e)}
                  />
                  <span class="ag-paging-page-summary-panel" role="presentation">
                    <div
                      id="btFirst"
                      ref="btFirst"
                      class="ag-paging-button ag-disabled"
                      role="button"
                      aria-label="First Page"
                      tabindex="0"
                      aria-disabled="true"
                    >
                      <span
                        class="ag-icon ag-icon-first"
                        unselectable="on"
                        role="presentation"
                        onClick={() => this.onBtFirst()}
                      ></span>
                    </div>
                    <div
                      id="btPrevious"
                      ref="btPrevious"
                      class="ag-paging-button ag-disabled"
                      role="button"
                      aria-label="Previous Page"
                      tabindex="0"
                      aria-disabled="true"
                    >
                      <span
                        class="ag-icon ag-icon-previous"
                        unselectable="on"
                        role="presentation"
                        onClick={() => this.onBtPrevious()}
                      ></span>
                    </div>
                    <span class="ag-paging-description" aria-hidden="true">
                      <span id="ag-445-start-page">Page </span>
                      <span id="ag-445-start-page-number" ref="lbCurrent" class="ag-paging-number">
                        0
                      </span>
                      <span id="ag-445-of-page"> of </span>
                      <span id="ag-445-of-page-number" ref="lbTotal" class="ag-paging-number">
                        0
                      </span>
                    </span>
                    <div
                      id="btNext"
                      ref="btNext"
                      class="ag-paging-button"
                      role="button"
                      aria-label="Next Page"
                      tabindex="0"
                      aria-disabled="false"
                    >
                      <span
                        class="ag-icon ag-icon-next"
                        unselectable="on"
                        role="presentation"
                        onClick={() => this.onBtNext()}
                      ></span>
                    </div>
                    <div
                      id="btLast"
                      ref="btLast"
                      class="ag-paging-button"
                      role="button"
                      aria-label="Last Page"
                      tabindex="0"
                      aria-disabled="false"
                    >
                      <span
                        class="ag-icon ag-icon-last"
                        unselectable="on"
                        role="presentation"
                        onClick={() => this.onBtLast()}
                      ></span>
                    </div>
                  </span>
                </div>
              </div>
            </Grid>
          </Grid>
        </Grid>
        {openMasterCategorySideBar ? (
          <FormMasterCategory
            open={openMasterCategorySideBar}
            handleClose={this.handleClose}
            updateListCategory={this.updateListCategory}
            shop={shopsList && shopsList.values}
            category={selectedMasterCategory}
            typeCategory={typeCategory}
            updateOption={updateOption}
            cannabisTypeList={cannabisTypeList}
            cannabisTypeForState={cannabisTypeForState}
          />
        ) : null}

        <Menu
          id="long-menu"
          anchorEl={anchorEl}
          open={open}
          onClose={this.handleCloseMenu}
          PaperProps={{
            style: {
              maxHeight: ITEM_HEIGHT * 4.5,
              minWidth: 200,
            },
          }}
        >
          {categoryActions.map((option) => (
            <MenuItem key={option.key} onClick={() => this.handleActionEvent(option.key)}>
              {option.value}
            </MenuItem>
          ))}
        </Menu>

        <ModalUpdateMasterCategory
          open={modalCategoryMaster}
          handleClose={this.handleCloseModalCategoryMaster}
          masterCategories={selectedRows}
          optionToBulkUpdate={optionToBulkUpdate}
          updateListCategory={this.updateListCategory}
          typeCategory={typeCategory}
          processOnGrid={this.processOnGrid}
        />
        {showModalConfirmation && (
          <ConfirmationModal
            open={showModalConfirmation}
            keyOption={key}
            close={this.closeConfirmationModal}
            {...modalDetail}
            handleContinue={this.updateMasterCategory}
          />
        )}
      </React.Fragment>
    )
  }
}

const MasterCatalogWithTitle = ContainerWithTitle(MasterCatalog, 'Master Categories')
const MasterCatalogConnected = connect(
  ({ dispatch, masterCatalogReducer, shopReducer, companyReducer }) => ({
    dispatch,
    masterCatalogReducer,
    shopReducer,
    companyReducer,
  }),
)(MasterCatalogWithTitle)

export default MasterCatalogConnected



// WEBPACK FOOTER //
// ./src/containers/Settings/MasterCatalog/MasterCategories.js